'use client';
import { sendGTMEvent } from '../sendGTMEvent';

/**
 * Tracks menu click events when users navigate using the menu system.
 * 
 * This function tracks hierarchical menu navigation with up to 3 levels:
 * - Level 1: Main menu items (e.g., "Alle Produkter")
 * - Level 2: Category titles (e.g., "Volvo", "Batterier og lader")
 * - Level 3: Sub-category items (e.g., "300SL Gullwing (W198)")
 * 
 * @param menuLevel - The level of the menu click (1, 2, or 3)
 * @param menuLabel1 - The first level menu label
 * @param menuLabel2 - The second level menu label (optional)
 * @param menuLabel3 - The third level menu label (optional)
 */
export const trackMenuClick = (
  menuLevel: 1 | 2 | 3,
  menuLabel1: string,
  menuLabel2?: string,
  menuLabel3?: string
) => {
  const eventData: any = {
    event: 'menu_click',
    menu_level: menuLevel.toString(),
    menu_label_1: menuLabel1,
  };

  // Only add menu_label_2 and menu_label_3 if they have actual values
  if (menuLabel2) {
    eventData.menu_label_2 = menuLabel2;
  }
  if (menuLabel3) {
    eventData.menu_label_3 = menuLabel3;
  }

  sendGTMEvent(eventData);
};